export default __webpack_public_path__ + "static/media/logo.31df0ce8.svg";